
import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DownloadBlue from "assets/images/Download-blue.svg";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { getMachineHistoryAPI } from "services/inspectionRequest";

export default function MachineHistoryList(props) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
  

  useEffect(() => {
    fetchRequests();
  }, []);


  //download pdf method
  const handleDownload = async (downloadLink, name) =>{
    const response = await fetch(downloadLink);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute(
      "download", name+'.pdf');
    document.body.appendChild(link);
    link.click();

  }


  // get all history list api
  const fetchRequests = async () => {
    setLoading(true);
    const machine_id = props.machineId;
    getMachineHistoryAPI( machine_id).then((response) => {
      console.log("data", response)
      setData(response);     
      setLoading(false);
    });
  };


  // datatable column
  const columns = [
    {
      sortable: true,
      name: "Previous SR No.",
      minWidth: "15%",
      selector: (row) => {
        return row?.Inspection.sr_number;
      },

    },
    {
      sortable: true,
      name: "Previous Inspection Dates",
      minWidth: "200px",
      selector: (row) => {
        return moment(row?.Inspection.inspection_date).format('MM-DD-YYYY');
      },

    },
    {
      sortable: true,
      name: "Inspector Name",
      maxWidth: "170px",
      minWidth: "170px",
      selector: "created_at",
      sort_column: "created_at",
      selector: (row) => {
        return row?.Inspection?.inspector?.full_name;
      },

    },
    {
      sortable: true,
      name: "Document Set",
      maxWidth: "170px",
      minWidth: "170px",
      selector: "created_at",
      sort_column: "created_at",
      cell: (row) =>{ return <div className=""> <span onClick={()=>{handleDownload(row.certificateData.issue_certificate,row?.Inspection.sr_number )}}><img
     
      src={DownloadBlue}
      className="me-2 w-24"
      role="button"
    /></span> </div>}
    },
  ];



  return (
    <div className="container-fluid">
      <div className="row">
       
       {loading ? <Spinner />: <div className="col-12">
          <DataTable
            columns={columns}
            data={data}
            className="datatable"
            paginationServer={false}
            sortServer={false}
            noHeader
            progressPending={loading}
          />
        </div>}
      </div>
    </div>
  );
}
